import React from 'react';
import { Link } from 'react-router-dom';

const Logo = function () {
  return (
    <Link to="/">
      <img src="/img/logo.svg" alt="logo" />
    </Link>
  );
};

export default Logo;
